import {useTranslation} from "react-i18next";
import {Button, ColorInput, Group, Stack, Switch, Textarea, TextInput} from "@mantine/core";
import {useTagDefinitionFormContext} from "./useTagDefinitionForm";
import {TagDefinitionFormProps} from "./TagDefinitionForm";

export type TagDefinitionFormFieldProps = Pick<TagDefinitionFormProps, 'options'> & {}

export const TagDefinitionFormFields = (props: TagDefinitionFormFieldProps) => {
  const {
    options,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useTagDefinitionFormContext();

  return (
    <Stack spacing="xs">
      <TextInput
        size="xs"
        label={t("common.entity.tagdefinition.form.field.label", "Label")}
        placeholder={t<string>("common.entity.tagdefinition.form.field.label.placeholder", "Label")}
        withAsterisk
        required
        {...form.getInputProps('label')}/>

      <Textarea
        size="xs"
        label={t("common.entity.tagdefinition.form.field.desc", "Description")}
        placeholder={t<string>("common.entity.tagdefinition.form.field.desc.placeholder", "Description")}
        minRows={4}
        autosize
        {...form.getInputProps('description')} />

      <ColorInput
        size="xs"
        label={t("common.entity.tagdefinition.form.field.color", "Color")}
        placeholder={t<string>("common.entity.tagdefinition.form.field.color.placeholder", "-")}
        format="hex"
        withEyeDropper={false}
        {...form.getInputProps('colorHex')} />

      <Group>
        <Button size="xs" variant="subtle" compact={true} onClick={() => form.setFieldValue('colorHex', undefined)}>
          {t("common.action.clear", "Clear")}
        </Button>
      </Group>

      <Switch
        size="xs"
        mt="md"
        label={t("common.entity.tagdefinition.form.field.donotuse", "Do Not Use")}
        {...form.getInputProps("doNotUse", {type: 'checkbox'})} />

    </Stack>
  )
}
